import React from "react";
import { Link } from "react-router-dom";
import "./home.css";
import { Avatar } from "@mui/material";
import Search from "../components/Search";
import logo from "../assets/icons/appsMenu.svg";
import BottomBar from "../components/BottomBar";

function Home() {
  return (
    <div className="Home">
      <div className="home__header">
        <div className="home__headerRight">
          {/* Gmail Link */}
          <Link to="/gmail">Gmail</Link>
          <div className="appsIcon">
            <img src={logo} alt="" />
          </div>
          <Avatar />
          {/* Icon */}
          {/* Avatar */}
        </div>
      </div>
      <div className="home__body">
        <img
          src="https://upload.wikimedia.org/wikipedia/commons/thumb/2/2f/Google_2015_logo.svg/368px-Google_2015_logo.svg.png"
          alt=""
        />
        <Search />
      </div>
      <BottomBar />
    </div>
  );
}

export default Home;
